export const SessionStorageKeys = {
  LOCATION: 'location',
  SCHEDULE_LOCATION: 'schedule-location',
  SCHEDULE_DATE: 'schedule-date',
};
